import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offer-thank-you',
  templateUrl: './offer-thank-you.component.html',
  styleUrls: ['./offer-thank-you.component.scss']
})
export class OfferThankYouComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
